import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import {
	MatPaginatorIntl,
	MatPaginatorModule,
} from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';

import { OrganizationsRoutingModule } from '../../sanus/organizations/organizations-routing.module';
import { PaginatorIntl } from '../../shared/internationalizations/paginator-intl';
import { SharedModule } from '../../shared/shared.module';

import { OrganizationsService } from './organizations.service';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatDialogModule,
		MatPaginatorModule,
		MatTableModule,
		OrganizationsRoutingModule,
		SharedModule,
	],
	providers: [
		{ provide: MatPaginatorIntl, useClass: PaginatorIntl },
		OrganizationsService,
	],
})
export class OrganizationsModule {}
